module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences@2x-5d35e04d6088847aece2570acbec5edc.webp";